export const TASK_HISTORY_SEARCH = 'TASK_HISTORY_SEARCH';
export const TASK_HISTORY_SEARCH_ERROR = 'TASK_HISTORY_SEARCH_ERROR';
export const TASK_HISTORY_SEARCH_SUCCESS = 'TASK_HISTORY_SEARCH_SUCCESS';
export const CLEAR_TASK_HISTORY_SEARCH = 'CLEAR_TASK_HISTORY_SEARCH';